import { ActionHistory } from "../Audits/action-history";
import { QuestionAttachment } from "../Audits/question-attachment";
import { AuditLocation } from "../Locations/audit-location";
import { ActionResponse } from "./action-response";

export class Action{
    public ActionID:number = -1;
    public ActionDescription:string = "";
    public Reference:string ="";
    public ReferenceQuestionHeader:string ="";
    public ReferenceQuestionBody:string ="";
    public ActionDeadline:Date = new Date();
    public ActionAssignee:string = "";
    public ActionOwnerTypeID:number = -1;
    public Result:string = "";
    public Comments:string = "";
    public QuestionHeader:string = "";
    public QuestionBody:string = "";
    public QuestionHelpText:string = "";
    public QuestionIdentifiers:string = "";
    public QuestionTypeID:number = -1;
    public AuditText:string = "";
    public AuditLocation:AuditLocation = new AuditLocation();
    public DateRecorded:Date = new Date();
    public ActionResponseList:ActionResponse[]=[];
    public Resolved:boolean = false;
    public ResolvedDate:Date = new Date();
    public ResolvedUser:string = "";
    public ActionCreator:string = "";
    public ActionOwnerID:number = -1;
    public NewNote:string = "";
    public History:ActionHistory[] = [];
    public Photos:string[] = [];
    public ActionPhotos:string[]=[];
    public ActionAttachments:QuestionAttachment[]=[];
    public Attachments:QuestionAttachment[] = [];
    public EventID:number = -1;
    public ActionTypeID:number = -1;
    public AuditResultDetailID:number = -1;
    public ActionVariationID:number = 1;
    public AuditID:number = -1;
    public ParentActionID:number = -1;
    public AuditName:string = "";
    public EventSummary:string = "";
    public EventName?: string;
    public EventLocationName?: string;
    public WorkflowActionTitle?: string;
    public WorkflowName?: string;
    public RequiredAuditID?: number;
    public RequiredAuditName?: string;
    public SourceType?: string;
    public Mandatory?: boolean;
    public AuditResultID:number = -1;
    public AuditCompletedDate?: Date;
    public AuditCompletedBy?: string;
    constructor(values: Object = {}){
        Object.assign(this, values);
        if(values.hasOwnProperty('ActionResponseList')){
            this.ActionResponseList = [];
            ((values as Action)['ActionResponseList'] as ActionResponse[]).forEach(element => {
                this.ActionResponseList.push(new ActionResponse(element));
            });
        }
        if(values.hasOwnProperty('AuditLocation')){
            this.AuditLocation = new AuditLocation((values as Action)['AuditLocation'] as AuditLocation);
        }
        if(values.hasOwnProperty('History')){
            this.History = [];
            ((values as Action)['History'] as ActionHistory[]).forEach(element => {
                this.History.push(new ActionHistory(element));
            });
         } 
         if(values.hasOwnProperty('Photos')){
            this.Photos = [];
            ((values as Action)['Photos'] as string[]).forEach(element => {
                this.Photos.push(element.toString());
            });
         } 
        if(values.hasOwnProperty('Attachments')){
            this.Attachments = [];
            ((values as Action)['Attachments'] as QuestionAttachment[]).forEach(element => {
                this.Attachments.push(new QuestionAttachment(element));
            });
         } 
         if(values.hasOwnProperty('ParentActionID')){
            this.ParentActionID = (values as Action)['ParentActionID'] as number;
         }
         if(values.hasOwnProperty('EventSummary')){
            this.EventSummary = (values as Action)['EventSummary'] as string;
         }
    }
}
